// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wsp__inline[data-v-4b877341]{display:grid;grid-template-columns:11fr 1fr 11fr}.wsp__phone[data-v-4b877341]{display:grid;grid-template-columns:5fr 1fr 17fr}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
